/** @jsx jsx */
import { jsx, css } from "@emotion/core";

import Menu from "./Menu";

const styles = css`
  padding: 20px;
  height: 100px;
  position: fixed;
  text-align: center;
  width: 100%;
  box-shadow: 10px 10px 10px rgba(010, 010, 010, 0.3);
  border-bottom: 1px #000 solid;
  z-index: 999;
  background: rgba(0, 0, 0, 0.4);
  box-sizing: border-box;

  .logo {
    max-width: 400px;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    padding: 15px;
    height: 80px;

    .logo {
      max-width: 300px;
    }
  }

  @media (max-width: 480px) {
    padding: 10px;
    height: 70px;

    .logo {
      max-width: 200px;
    }
  }
`;

const Header = () => (
  <header css={styles}>
    <div className="logo">
      <img src="/assets/logo2.png" alt="Andesh Logo" width="100%" />
    </div>
    <Menu />
  </header>
);

export default Header;
